/* PSO.js */
/* @author: anghello */

import axios from 'axios';
import * as CryptoJS from 'crypto-js';
import { buildDsParam } from './dsParam';

const REACT_APP_PZ_PSO = process.env.REACT_APP_PZ_PSO;
const REACT_APP_PZ_PSO_COLLECTION = process.env.REACT_APP_PZ_PSO_COLLECTION;
const REACT_APP_PZ_PSO_EXPORTED = process.env.REACT_APP_PZ_PSO_EXPORTED;
const REACT_APP_PZ_PSO_CREDITS = process.env.REACT_APP_PZ_PSO_CREDITS;
const REACT_APP_PZ_PSO_AI = process.env.REACT_APP_PZ_PSO_AI;
const BASE_APP = process.env.REACT_APP_NAME;
const BASE_CLIENT = process.env.REACT_APP_CLIENT;
const BASE_VERSION = process.env.REACT_APP_VERSION;
const BASE_BUILD = process.env.REACT_APP_BUILD;
const BASE_DS = buildDsParam(BASE_APP, BASE_CLIENT);
const BASE_URL = `${REACT_APP_PZ_PSO}client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}&ds=${encodeURIComponent(BASE_DS)}`;
const BASE_URL_COLLECTION = `${REACT_APP_PZ_PSO_COLLECTION}client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}&ds=${encodeURIComponent(BASE_DS)}`;
const BASE_URL_EXPORTED = `${REACT_APP_PZ_PSO_EXPORTED}client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}&ds=${encodeURIComponent(BASE_DS)}`;
const BASE_URL_CREDITS = `${REACT_APP_PZ_PSO_CREDITS}client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}&ds=${encodeURIComponent(BASE_DS)}`;
const BASE_URL_AI = `${REACT_APP_PZ_PSO_AI}client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}&ds=${encodeURIComponent(BASE_DS)}`;
const APPLE_MUSIC_DECRYPT_KEY = process.env.REACT_APP_APPLE_MUSIC_DECRYPT_KEY;
const APPLE_MUSIC_DECRYPT_IV = process.env.REACT_APP_APPLE_MUSIC_DECRYPT_IV;

const api = axios.create();
const _timestamp = () => Math.floor(Date.now() / 1000);

const PSO = {
  appleMusicToken: null,

  getCollectionListByOwner: async function ({ un, al, lastId = null, mock = false }) {
    const args = {
      av: 'v2',
      un: un,
      al: al,
      colt: 1
    };

    if (lastId) {
      args.lastId = lastId;
    }

    const m = 'pso.collection.getCollectionListByOwner';
    const _t = _timestamp();
    const url = `${BASE_URL_COLLECTION}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    if (mock) {
      return url;
    }

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getCollectionPars: async function ({ un, al, colid }) {
    const args = {
      av: 'v2',
      un: un,
      al: al,
      colid
    };
    const m = 'pso.collection.getCollectionPars';
    const _t = _timestamp();
    const url = `${BASE_URL_COLLECTION}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createCollection: async function ({ un, al, colt, colevt, coln, cold, colloc, colds, colde, colpri, coltic, colpar, colurl, colcurl, colorg, colad, collati, collong, colevcat }) {
    const args = { av: 'v2', un, al, colt, colevt };

    if (coln) args.coln = encodeURIComponent(coln);
    if (cold) args.cold = encodeURIComponent(cold);
    if (colloc) args.colloc = encodeURIComponent(colloc);
    if (colds) args.colds = encodeURIComponent(colds);
    if (colde) args.colde = encodeURIComponent(colde);
    if (colpri) args.colpri = encodeURIComponent(colpri);
    if (coltic) args.coltic = encodeURIComponent(coltic);
    if (colpar) args.colpar = encodeURIComponent(colpar);
    if (colurl) args.colurl = encodeURIComponent(colurl);
    if (colcurl) args.colcurl = encodeURIComponent(colcurl);
    if (colorg) args.colorg = encodeURIComponent(colorg);
    if (colad) args.colad = encodeURIComponent(colad);
    if (collati) args.collati = encodeURIComponent(collati);
    if (collong) args.collong = encodeURIComponent(collong);
    if (colevcat) args.colevcat = colevcat;

    const m = 'pso.collection.createCollection';
    const _t = _timestamp();
    const url = `${BASE_URL_COLLECTION}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  removeCollection: async function ({un, al, colid}) {
    const args = { av: 'v2', un, al, colid };
    const m = 'pso.collection.removeCollection';
    const url = `${BASE_URL_COLLECTION}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  modifyCollection: async function ({ un, al, colid, colt, colevt, coln, cold, colloc, colds, colde, colpri, coltic, colpar, colurl, colcurl, colorg, colad, collati, collong, colevcat }) {
    const args = { av: 'v2', un, al, colid };

    if (coln) args.coln = encodeURIComponent(coln);
    if (cold) args.cold = encodeURIComponent(cold);
    if (colt) args.colt = colt;
    if (colevt) args.colevt = colevt;
    if (colloc) args.colloc = encodeURIComponent(colloc);
    if (colds) args.colds = encodeURIComponent(colds);
    if (colde) args.colde = encodeURIComponent(colde);
    if (colpri) args.colpri = encodeURIComponent(colpri);
    if (coltic) args.coltic = encodeURIComponent(coltic);
    if (colpar) args.colpar = encodeURIComponent(colpar);
    if (colurl) args.colurl = encodeURIComponent(colurl);
    if (colcurl) args.colcurl = encodeURIComponent(colcurl);
    if (colorg) args.colorg = encodeURIComponent(colorg);
    if (colad) args.colad = encodeURIComponent(colad);
    if (collati) args.collati = encodeURIComponent(collati);
    if (collong) args.collong = encodeURIComponent(collong);
    if (colevcat) args.colevcat = colevcat;

    const m = 'pso.collection.modifyCollection';
    const _t = _timestamp();
    const url = `${BASE_URL_COLLECTION}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getRemixListByCollection: async function ({ un, al, colid }) {
    const args = { av: 'v2', un, al, colid };
    const m = 'pso.collection.getRemixListByCollection';
    const _t = _timestamp();
    const url = `${BASE_URL_COLLECTION}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  addRemixToCollection: async function ({ un, al, colid, rid }) {
    const args = { av: 'v2', un, al, colid, rid };
    const m = 'pso.collection.addRemixToCollection';
    const _t = _timestamp();
    const url = `${BASE_URL_COLLECTION}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  removeRemixFromCollection: async function ({ un, al, colid, rid }) {
    const args = { av: 'v2', un, al, colid, rid };
    const m = 'pso.collection.removeRemixFromCollection';
    const _t = _timestamp();
    const url = `${BASE_URL_COLLECTION}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getRemixListByOwner: async function ({ un, al, username, rnmax = 25, ridul, rtsul, getcover }) {
    const args = { av: 'v2', un, al, rown: username, rnmax };
    if (ridul) { args.ridul = ridul; }
    if (rtsul) { args.rtsul = rtsul; }
    if (getcover) { args.getcover = getcover; }
    const m = 'pso.remix.getRemixListByOwner';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getHomeRemixList: async function ({ un, al, username, rnmax = 25, ridul, rtsul, getcover }) {
    const args = { av: 'v2', un, al, rown: username, rnmax };
    if (ridul) { args.ridul = ridul; }
    if (rtsul) { args.rtsul = rtsul; }
    if (getcover) { args.getcover = getcover; }
    const m = 'pso.remix.getHomeRemixList';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getInputUsersInRemix: async function ({ un, al, rid, etype, getblockeduserinfo, getauthorizeduserinfo, sun, inpunmax }) {
    const args = { av: 'v2', un, al, rid };

    if (etype) args.etype = etype;
    if (getblockeduserinfo) args.getblockeduserinfo = getblockeduserinfo;
    if (getauthorizeduserinfo) args.getauthorizeduserinfo = getauthorizeduserinfo;
    if (sun) args.sun = sun;
    if (inpunmax) args.inpunmax = inpunmax;

    const m = 'pso.remix.getInputUsersInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getBlockedInputUserListByRemix: async function ({ un, al, rid, unmax }) {
    const args = { av: 'v2', un, al, rid };

    if (unmax) args.unmax = unmax;

    const m = 'pso.remix.getBlockedInputUserListByRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getAuthorizedInputUserListByRemix: async function ({ un, al, rid, unmax }) {
    const args = { av: 'v2', un, al, rid };

    if (unmax) args.unmax = unmax;

    const m = 'pso.remix.getAuthorizedInputUserListByRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getRemixElementsAllByRemixOwner: async function ({ un, al, estatus, etype, enmax }) {
    const args = { av: 'v2', un, al };

    if (estatus) args.estatus = estatus;
    if (etype) args.etype = etype;
    if (enmax) args.enmax = enmax;

    const m = 'pso.remix.getRemixElementsAllByRemixOwner';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getRemixApprovedElements: async function ({ un, al, enmax, rid, esort, eidul, esvul, esticknul }) {
    const args = { av: 'v2', un, al, rid };

    if (enmax !== undefined) { args.enmax = enmax; }
    if (esort !== undefined) { args.esort = esort; }
    if (eidul !== undefined) { args.eidul = eidul; }
    if (esvul !== undefined) { args.esvul = esvul; }
    if (esticknul !== undefined) { args.esticknul = esticknul; }

    const m = 'pso.remix.getRemixApprovedElements';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getRemixNonApprovedElements: async function ({ un, al, enmax, rid, estatus, eidul, esvul, esticknul }) {
    const args = { av: 'v2', un, al, rid };

    if (enmax !== undefined) { args.enmax = enmax; }
    if (estatus !== undefined) { args.estatus = estatus; }
    if (eidul !== undefined) { args.eidul = eidul; }
    if (esvul !== undefined) { args.esvul = esvul; }
    if (esticknul !== undefined) { args.esticknul = esticknul; }

    const m = 'pso.remix.getRemixNonApprovedElements';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getStickyElementIDListInRemix: async function ({ un, al, enmax, rid, etype }) {
    const args = { av: 'v2', un, al, rid };

    if (enmax) args.enmax = enmax;
    if (etype) args.etype = etype;

    const m = 'pso.remix.getStickyElementIDListInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  approveElementInRemix: async function ({ un, al, rid, etype, eid }) {
    const args = { av: 'v2', un, al, rid, etype, eid };

    const m = 'pso.remix.approveElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  disapproveElementInRemix: async function ({ un, al, rid, etype, eid }) {
    const args = { av: 'v2', un, al, rid, etype, eid };

    const m = 'pso.remix.disapproveElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  removeElementFromRemix: async function ({ un, al, rid, etype, eid }) {
    const args = { av: 'v2', un, al, rid, etype, eid };

    const m = 'pso.remix.removeElementFromRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  likeElementInRemix: async function ({ un, al, rid, eid, etype }) {
    const args = { av: 'v2', un, al, rid, eid, etype };

    const m = 'pso.remix.likeElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  unlikeElementInRemix: async function ({ un, al, rid, eid, etype }) {
    const args = { av: 'v2', un, al, rid, eid, etype };

    const m = 'pso.remix.unlikeElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getLikeElementInRemix: async function ({ un, al, rid, eid, etype }) {
    const args = { av: 'v2', un, al, rid, eid, etype };

    const m = 'pso.remix.getLikeElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  blockInputUserForRemix: async function ({ un, al, rid, blckun }) {
    const args = { av: 'v2', un, al, rid, blckun };

    const m = 'pso.remix.blockInputUserForRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  unblockInputUserForRemix: async function ({ un, al, rid, blckun }) {
    const args = { av: 'v2', un, al, rid, blckun };

    const m = 'pso.remix.unblockInputUserForRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  authorizeInputUserForRemix: async function ({ un, al, rid, authun }) {
    const args = { av: 'v2', un, al, rid, authun };

    const m = 'pso.remix.authorizeInputUserForRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  unauthorizeInputUserForRemix: async function ({ un, al, rid, authun }) {
    const args = { av: 'v2', un, al, rid, authun };

    const m = 'pso.remix.unauthorizeInputUserForRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getRemixElementsAllByInputUser: async function ({ un, al, estatus, etype, enmax, lastupdate, lasteid, lastrid, ascendent }) {
    const args = { av: 'v2', un, al };

    if (estatus) args.estatus = estatus;
    if (etype) args.etype = etype;
    if (enmax) args.enmax = enmax;
    if (ascendent) args.ascendent = ascendent;
    if (lastupdate) args.lastupdate = lastupdate;
    if (lasteid) args.lasteid = lasteid;
    if (lastrid) args.lastrid = lastrid;

    const m = 'pso.remix.getRemixElementsAllByInputUser';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getRemixPars: async function ({ un, al, rid, esort, easc, getappelements, getinputusers, getpropsjs, getisfollower, usecreatoresort, getbadgeapp, getrnphotos, getcover }) {
    const args = { av: 'v2', un, al, rid };

    if (esort) args.esort = esort;
    if (easc) args.easc = easc;
    if (getappelements) args.getappelements = getappelements;
    if (getinputusers) args.getinputusers = getinputusers;
    if (getpropsjs) args.getpropsjs = getpropsjs;
    if (getisfollower) args.getisfollower = getisfollower;
    if (usecreatoresort) args.usecreatoresort = usecreatoresort;
    if (getbadgeapp) args.getbadgeapp = getbadgeapp;
    if (getrnphotos) args.getrnphotos = getrnphotos;
    if (getcover) args.getcover = '1';

    const m = 'pso.remix.getRemixPars';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  modifyRemix: async function ({ un, al, rid, args }) {
    args = {
      av: 'v2',
      un,
      al: al,
      rid: rid,
      ...args
    };

    const m = 'pso.remix.modifyRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
        }
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  replaceOldestExistingElementInRemix: async function ({ un, al, rid, e_sid, etype }) {
    const args = {
      av: 'v2',
      un: un,
      al: al,
      rid: rid,
      e_sid: e_sid,
      etype: etype
    };

    const m = 'pso.remix.replaceOldestExistingElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getAppleMusicToken: async function ({ force }) {
    if (this.appleMusicToken === null || force) {
      const args = {};
      args.av = 'v2';
      if (force) { args.fnew = 1; }

      // Parameters for this method hardcoded because this method requires this
      const client = 'web';
      const app = 'pbmv';
      const at = 'n';
      const v = BASE_VERSION;
      const m = 'pso.token.getAM';
      const url = `${REACT_APP_PZ_PSO}client=${client}&app=${app}&version=${v}&at=${at}&m=${m}&args=${JSON.stringify(args)}`;

      try {
        const resp = await api({
          method: 'GET',
          url: url
        });

        if (resp && resp.data && resp.data.result && resp.data.result === 'success') {
          const token = resp.data.tk;

          const padding = CryptoJS.pad.Pkcs7;
          const parsedKey = CryptoJS.SHA256(APPLE_MUSIC_DECRYPT_KEY).toString().substring(0, 32);
          const parsedIv = CryptoJS.SHA256(APPLE_MUSIC_DECRYPT_IV).toString().substring(0, 16);

          const key = CryptoJS.enc.Utf8.parse(parsedKey);
          const iv = CryptoJS.enc.Utf8.parse(parsedIv);
          const decrypted = CryptoJS.AES.decrypt(token, key, { iv: iv, padding: padding });
          const tokenStrDecrypted = decrypted.toString(CryptoJS.enc.Utf8);

          this.appleMusicToken = tokenStrDecrypted;
        }
      } catch (err) {
        console.error(err);
      }
    }
  },

  getAppleMusicTopMusics: async function ({ force = false }) {
    const type = 'songs';
    const limit = 10;
    const url = `https://api.music.apple.com/v1/catalog/us/charts?types=${type}&limit=${limit}`;

    await this.getAppleMusicToken({ force });

    const token = this.appleMusicToken;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
          'Authorization': `Bearer ${token}`
        },
      })
        .then((response) => {
          let data;
          const results = response.data.results;
          if (results && results.songs && results.songs[0] && results.songs[0].data) {
            data = results.songs[0].data;
          }

          resolve(data);
        })
        .catch((err) => {
          const errorObj = { message: '', status: null };
          if (err && err.response && err.response.data && err.response.data.message) {
            errorObj.message = err.response.data.message;
          }
          if (err && err.response && err.response.status) {
            errorObj.status = err.response.status;
          }
          return reject(errorObj);
        });
    });
  },

  searchAppleMusic: async function ({ search, force = false }) {
    const type = 'songs';
    const limit = 10;
    const url = `https://api.music.apple.com/v1/catalog/us/search?term=${search}&limit=${limit}&types=${type}`;

    await this.getAppleMusicToken({ force });

    const token = this.appleMusicToken;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
          'Authorization': `Bearer ${token}`
        },
      })
        .then((response) => {
          let data;

          const results = response.data.results;
          if (results && results.songs && results.songs && results.songs.data) {
            data = results.songs.data;
          }

          resolve(data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  appleMusicSearchID: async function ({ term, force = false }) {
    const url = `https://api.music.apple.com/v1/catalog/us/songs?ids=${term}`;

    await this.getAppleMusicToken({ force });

    const token = this.appleMusicToken;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
        headers: {
          'cache': false,
          'processData': false,
          'Access-Control-Allow-Origin': '*',
          'crossDomain': true,
          'Authorization': `Bearer ${token}`
        },
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  uploadUserSong: async function (args, file, filename = null) {
    args = {
      av: 'v2',
      ...args
    };

    const m = 'pso.remix.uploadUserSong';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;
		
		const formData = new FormData();
    if (filename) { formData.append('Filedata', file, filename); }
    else { formData.append('Filedata', file); }

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getMediaPack: async (args) => {
    args = {
      av: 'v2',
      ...args
    };

    const m = 'pso.mediapack.getmediapack';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  nodepath: async (args) => {
    args = { av: 'v2', ...args };

    const m = 'pso.mediapack.nodepath';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },
  
  createRemixWithPhoto: async (args) => {
    args = {
      av: 'v2',
      ...args
    };
    const formData = new FormData();
    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    const m = 'pso.remix.createRemixWithPhoto';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createRemixWithVideo: async (args) => {
    args = {
      av: 'v2',
      ...args
    };
    const formData = new FormData();
    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    const m = 'pso.remix.createRemixWithVideo';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createRemixWithAIVideo: async (args) => {
    args = { av: 'v2', ...args };
    const formData = new FormData();
    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    const m = 'pso.remix.createRemixWithAIVideo';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url: url, data: formData })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createRemixWithAIPlusVideo: async (args) => {
    args = { av: 'v2', ...args };
    const formData = new FormData();
    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    const m = 'pso.remix.createRemixWithAIPlusVideo';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url: url, data: formData })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createRemixWithAIPhoto: async (args) => {
    args = { av: 'v2', ...args };
    const formData = new FormData();
    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    const m = 'pso.remix.createRemixWithAIPhoto';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url: url, data: formData })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  sendPhotoToRemix: async (args) => {
    args = {
      av: 'v2',
      ...args
    };

    const m = 'pso.remix.sendPhotoToRemix';

    const formData = new FormData();

    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  sendVideoToRemix: async (args) => {
    args = {
      av: 'v2',
      easv: '2',
      ...args
    };

    const m = 'pso.remix.sendVideoToRemix';

    const formData = new FormData();

    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  sendAIPlusVideoToRemix: async (args) => {
    args = {
      av: 'v2',
      easv: '2',
      ...args
    };

    const m = 'pso.remix.sendAIPlusVideoToRemix';

    const formData = new FormData();

    if (args['FileDataArray']) {
      args['FileDataArray'].forEach((file) => {
        formData.append('Filedata[]', file);
      });
      delete args['FileDataArray'];
    }

    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  sendAIPhotoToRemix: async (args) => {
    args = {
      av: 'v2',
      easv: '2',
      ...args
    };

    const m = 'pso.remix.sendAIPhotoToRemix';

    const formData = new FormData();

    if (args['FileDataArray']) {
      args['FileDataArray'].forEach((file) => {
        formData.append('Filedata[]', file);
      });
      delete args['FileDataArray'];
    }

    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  replacePhotoInRemix: async (args) => {
    args = {
      av: 'v2',
      ...args
    };

    const m = 'pso.remix.replacePhotoInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    const formData = new FormData();

    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  replaceVideoInRemix: async (args) => {
    args = {
      av: 'v2',
      ...args
    };

    const m = 'pso.remix.replaceVideoInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    const formData = new FormData();

    if (args['Filedata'] && args['Filename']) {
      formData.append('Filedata', args['Filedata'], args['Filename']);
      delete args['Filedata'];
    }

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  modifyStickyModeRemix: async ({ un, al, rid, rstickymode }) => {
    const args = {
      av: 'v2',
      un,
      al,
      rid,
      rstickymode
    };

    const m = 'pso.remix.modifyRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    const formData = new FormData();

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  insertStickyElementInRemix: async ({ un, al, rid, etype, eid, eorder }) => {
    const args = {
      av: 'v2',
      un,
      al,
      rid,
      etype,
      eid,
      eorder
    };

    const m = 'pso.remix.insertStickyElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    const formData = new FormData();

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  moveStickyElementInRemix: async ({ un, al, rid, etype, eid, eorder, eneworder, edoempty }) => {
    const args = {
      av: 'v2',
      un,
      al,
      rid,
      etype,
      eid,
      eorder,
      eneworder,
      edoempty
    };

    const m = 'pso.remix.moveStickyElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    const formData = new FormData();

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },
	
  removeStickyElementFromRemix: async ({ un, al, rid, etype, eid, eorder, edoempty }) => {
    const args = {
      av: 'v2',
      un,
      al,
      rid,
      etype,
      eid,
      eorder,
      edoempty
    };

    const m = 'pso.remix.removeStickyElementFromRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    const formData = new FormData();

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  checkStarTagExists: async function ({ un, al, rstag, getusersuggested }) {
    const args = { av: 'v2', un, al, rstag };
    if (getusersuggested) { args.getusersuggested = getusersuggested; }

    const m = 'pso.remix.checkStarTagExists';
    const _t = _timestamp();
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  modifyElementGlobal: async function ({ un, al, etype, eid, eaid, ept, ebo, ebodel }) {
    const args = { av: 'v2', un, al, etype, eid };
    if (eaid) { args.eaid = eaid; }
    if (ept) { args.ept = ept; }
    if (ebo) { args.ebo = ebo; }
    if (ebodel) { args.ebodel = ebodel; }

    const m = 'pso.remix.modifyElementGlobal';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  featureElementInRemix: async function ({ un, al, rid, etype, eid, efs, ecfs }) {
    const args = { av: 'v2', un, al, rid, etype, eid };

    if (efs) { args.efs = efs; }
    if (ecfs) { args.ecfs = ecfs; }

    const m = 'pso.remix.featureElementInRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  setRemixCover: async function ({ un, al, rid, eid }) {
    const args = { av: 'v2', un, al, rid, eid };

    const m = 'pso.remix.setRemixCover';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  notifyRemixReady: async function ({ un, al, rid }) {
    const args = { av: 'v2', un, al, rid };

    const m = 'pso.remix.notifyRemixReady';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  removeRemix: async ({ un, al, rid }) => {
    const args = { av: 'v2', un, al, rid };
    const m = 'pso.remix.removeRemix';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'POST',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getUserData: async ({ un, al, cid }) => {
    const args = { av: 'v2', un, al, cid };
    const m = 'pso.user.getUserData';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createExported: async ({ un, al, rid, mid, ti, bo }) => {
    const args = { av: 'v2', un, al, rid, mid, ti, bo };

    const m = 'pso.exported.createExported';
    const _t = _timestamp();
    const url = `${BASE_URL_EXPORTED}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getExportedListByUser: async ({ un, al, lastId, rnmax = 2 }) => {
    const args = { av: 'v2', un, al, rnmax };

    if (lastId) { args.lastId = lastId; }

    const m = 'pso.exported.getExportedListByUser';
    const _t = _timestamp();
    const url = `${BASE_URL_EXPORTED}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'GET', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  removeExported: async ({ un, al, mid }) => {
    const args = { av: 'v2', un, al, mid };

    const m = 'pso.exported.removeExported';
    const _t = _timestamp();
    const url = `${BASE_URL_EXPORTED}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getUserBalance: async ({ un, al, detailed }) => {
    const args = { av: 'v2', un, al };
    if (detailed) { args.detailed = detailed; }
    const m = 'pso.credits.getUserBalance';
    const _t = _timestamp();
    const url = `${BASE_URL_CREDITS}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getUserDataCredits: async ({ un, al, detailed=0 }) => {
    const args = { 'av':'v2', un, al, detailed };
    const m = 'pso.credits.getUserData';
    const _t = _timestamp();
    const url = `${BASE_URL_CREDITS}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getUserTransactions: async ({ un, al }) => {
    const args = { 'av':'v2', un, al };
    const m = 'pso.credits.getUserTransactions';
    const _t = _timestamp();
    const url = `${BASE_URL_CREDITS}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createSubscription: async ({ un, al, priceID, subscription, regularity }) => {
    const args = { 'av':'v2', un, al, priceID, subscription, regularity };
    const m = 'pso.subscription.createSubscription';
    const _t = _timestamp();
    const url = `${BASE_URL_CREDITS}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  cancelSubscription: async ({ un, al }) => {
    const args = { 'av':'v2', un, al };
    const m = 'pso.subscription.cancelSubscription';
    const _t = _timestamp();
    const url = `${BASE_URL_CREDITS}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getTransactionsPrices: async ({ un, al }) => {
    const args = { 'av':'v2', un, al };
    const m = 'pso.credits.getTransactionsPrices';
    const _t = _timestamp();
    const url = `${BASE_URL_CREDITS}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createCreditsPackage: async ({ un, al, priceID, amount }) => {
    const args = { 'av':'v2', un, al, priceID, amount };
    const m = 'pso.credits.createCreditsPackage';
    const _t = _timestamp();
    const url = `${BASE_URL_CREDITS}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  registerCreditsPackage: async ({ un, al, balance, productID, transactionID }) => {
    const args = { 'av':'v2', un, al, balance, productID, transactionID };
    const m = 'pso.credits.registerCreditsPackage';
    const _t = _timestamp();
    const url = `${BASE_URL_CREDITS}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getStory: async ({ un, al, category, topic }) => {
    const args = { 'av':'v2', un, al, category, topic };
    const m = 'pso.ai.getStory';
    const _t = _timestamp();
    const url = `${BASE_URL_AI}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getAIPlusVideoStatus: async (args) => {
    args = {
      av: 'v2',
      ...args
    };

    const m = 'pso.remix.getAIPlusVideoStatus';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getTitleFromPrompt: async ({ un, al, prompt }) => {
    const args = { 'av':'v2', un, al, prompt };
    const m = 'pso.ai.getTitleFromPrompt';
    const _t = _timestamp();
    const url = `${BASE_URL_AI}&m=${m}&args=${JSON.stringify(args)}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({ method: 'POST', url, })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getNews: async ({ un, al }) => {
    const args = { av: 'v2', un, al };

    const m = 'pso.out.getNews';
    const url = `${BASE_URL}&m=${m}&args=${JSON.stringify(args)}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

};

export default PSO;